import React from 'react'
import { Field, Input } from '@workwhile/ui'

export const ClockedTimeField = ({
  label,
  value,
  onChange,
  error,
}: {
  label: string
  value: string
  onChange: (newValue: string) => void
  error?: string
}) => (
  <Field
    label={label}
    error={error}
    // Intentionally disabled, lint throws an error because Field's mt is not defined in workwhile UI but it's a valid field
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    mt={0}
    flex="1"
  >
    <Input
      block
      type="datetime-local"
      step={60}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </Field>
)
